module.exports = __webpack_public_path__ + "img/ico-reaction-01.1de3b51d.svg";